import React, { useEffect } from "react";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Team Images
import Team1 from "../../ASSETS/IMAGES/BW_Adam_Maciak.png";
import Team2 from "../../ASSETS/IMAGES/BW_Roshni-Dasgupta.png";
import Team3 from "../../ASSETS/IMAGES/erica.png";
import Team4 from "../../ASSETS/IMAGES/dewanda_bw.png";
import Team5 from "../../ASSETS/IMAGES/Vishnu_BW.png";

const teamMembers = [
  { name: "Adam Maciak", role: "Founder & CEO", company: "KUR International", image: Team1 },
  { name: "Roshni Dasgupta", role: "Chief Financial Officer", company: "KUR International", image: Team2 },
  { name: "Erica Perry", role: "Director of Corporate Administration", company: "KUR International", image: Team3 },
  { name: "Dewanda Lumpkins", role: "Patient Scheduling Coord", company: "KUR Diagnostics", image: Team4 },
  { name: "Vishnu Muralidharan", role: "Global controller", company: "KUR International", image: Team5 },
];

const AboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <section className="about-section">
      <div className="about-container">

        <h1 className="about-title" data-aos="fade-up">
          About Us
        </h1>

        {/* Vision */}
        <div className="about-card" data-aos="fade-up" data-aos-delay="200">
          <h2 className="about-card-title">Our Vision</h2>
          <p className="about-card-text">
            Transforming preventive care to a higher standard.
          </p>
        </div>

        {/* Mission */}
        <div className="about-card" data-aos="fade-up" data-aos-delay="300">
          <h2 className="about-card-title">Our Mission</h2>
          <p className="about-card-text">
            To empower physicians with innovative, accessible technologies that make early detection practical, affordable, and standard in everyday care — Prevent progression by early detection.
          </p>
        </div>

        {/* Tagline */}
        <div className="about-highlight" data-aos="fade-up" data-aos-delay="400">
          <h3>Detect Early. Save Lives.</h3>
        </div>

        {/* Leadership Team */}
        <div className="team-section">
          <h2 className="team-title" data-aos="fade-up">
            Our Leadership Team
          </h2>

          <div className="team-grid-modern">
            {teamMembers.map((member, index) => (
              <div
                className="team-modern-item"
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 150}
              >
                <div className="team-modern-image-box">
  <img src={member.image} alt={member.name} className="team-modern-image" />
</div>


                <h4 className="team-modern-name">{member.name}</h4>
                <p className="team-modern-company">{member.company}</p>
                <p className="team-modern-role">{member.role}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;
